import { useApi } from 'services';

export const useCreateCreditAnalysis = () => useApi(`v2/credit-analysis`, 'POST', {}, {});

export const useUpdateCreditAnalysis = (idOperation) => useApi(`v2/credit-analysis/${idOperation}`, 'PUT', {}, {});